__turbopack_context__.v({
  "agentCursor": "TableGrid-module__3A678G__agentCursor",
  "agentCursorBox": "TableGrid-module__3A678G__agentCursorBox",
  "agentCursorPointer": "TableGrid-module__3A678G__agentCursorPointer",
  "agentCursorVanish": "TableGrid-module__3A678G__agentCursorVanish",
  "agentGlow": "TableGrid-module__3A678G__agentGlow",
  "agentGlowOn": "TableGrid-module__3A678G__agentGlowOn",
  "agentGlowPulse": "TableGrid-module__3A678G__agentGlowPulse",
  "agentGlowVanish": "TableGrid-module__3A678G__agentGlowVanish",
  "paper": "TableGrid-module__3A678G__paper",
  "sheet": "TableGrid-module__3A678G__sheet",
  "sheetCompact": "TableGrid-module__3A678G__sheetCompact",
});
